import { UserService } from './user.service';
import { SidenavService } from './sidenav.service';
import { IconRegistryService } from './icon-registry.service';

export const services = [UserService, SidenavService, IconRegistryService];

export * from './user.service';
export * from './sidenav.service';
